<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item label="表名" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag  :disabled="isDisableSelect"  type="list"  v-decorator="['type', validatorRules.type]" @change="selectChange" :trigger-change="true" dictCode="gold_stone_classify" placeholder="请选择表"/>
        </a-form-item>
        <a-form-item   label="上级名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag :disabled="isDisableSelect" type="list"  v-decorator="['parentName', validatorRules.parentName]" :trigger-change="true" :dictCode="dictFindCode" placeholder="请选择上级名称"/>
        </a-form-item>
        <a-form-item label="名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'searchName', validatorRules.searchName]" placeholder="请输入名称"></a-input>
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import JMultiSelectTag from "@/components/dict/JMultiSelectTag"

  export default {
    name: "GoldStoneClassifyManageModal",
    components: { 
      JDictSelectTag,
      JMultiSelectTag,
    },
    data () {
      return {
        dictFindCode:"golden_stone_tabletype",
        isDisableSelect:false,
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          type: {rules: [
            {required: true, message: '请选择表!'},
          ]},
          parentName: {rules: [
          ]},
          searchName: {rules: [
            {required: true, message: '请输入名称!'},
          ]},
        },
        url: {
          add: "/goldenstone.base/goldStoneClassifyManage/add",
          edit: "/goldenstone.base/goldStoneClassifyManage/edit",
        }
      }
    },
    created () {
    },
    methods: {
      selectChange(SelectDict){
        switch (SelectDict) {
          case "1":
            //产品
            this.form.resetFields(['parentName'])
            this.dictFindCode="golden_stone_tabletype,search_name,id"
            break;
          case "2":
            //系列
            this.form.resetFields(['parentName'])
            this.dictFindCode="golden_stone_stonetype,search_name,id"
            break;
          case "3":
            //花色
            this.form.resetFields(['parentName'])
            this.dictFindCode="golden_stone_stoneseries,search_name,id"
            break;
          default:
            break;
        }
        
      },
      add () {
        this.form.resetFields();
        this.model = Object.assign({}, {});
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'type','parentId','parentName','searchName'))
        })
         this.isDisableSelect=false;
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'type','parentId','parentName','searchName'))
        })
        this.isDisableSelect=true;
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'type','parentId','parentName','searchName'))
      },

      
    }
  }
</script>